define('plugins/musicfavourite/nls/menuOptions',{
    'en-gb': {
        'options': {
            'feedbackOption': 'Don\'t recommend this again',
            'preFeedbackText': '',
            'feedbackConfirmation': 'Will not be recommended again',
            'undo': 'Undo'
        }
    },
    'cy-gb': { //WELSH
        'options': {
            'feedbackOption': 'Peidio argymell hwn eto',
            'preFeedbackText': 'Ni fydd',
            'feedbackConfirmation': 'yn cael ei argymell eto',
            'undo': 'Dad-wneud'
        }
    },
    'ga-gb': { //IRISH
        'options': {
            'feedbackOption': 'N&aacute; mol &eacute; seo ar&iacute;s',
            'preFeedbackText': 'N&iacute; mholfar',
            'feedbackConfirmation': 'ar&iacute;s',
            'undo': 'Cealaigh'
        }
    },
    'gd-gb': { //SCOTTISH
        'options': {
            'feedbackOption': 'Na mol seo a-rithist',
            'preFeedbackText': '',
            'feedbackConfirmation': 'Cha t&egrave;id a mholadh a-rithist',
            'undo': 'Air ais'
        }
    }
});

